// tslint:disable: prefer-output-readonly max-line-length restrict-plus-operands prefer-template no-void-expression
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Injector,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
} from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";

import { switchMap } from "rxjs/operators";

import { CookieService } from "ngx-cookie";

import { ModalService } from "pf_styleguide";

import { HeaderService } from "../header/header.service";
import { SportToPitchCourtTextPipe } from "../pipe/sport-to-pitch-court-text.pipe";
import { CitySelectService } from "../shared/city-select.service";
import { MlpHelper } from "../shared/mlpHelper";
import { Pitch, PitchData } from "../shared/model/pitch";
import { VenueData } from "../shared/model/venue";
import { AuthService } from "../shared/module/auth/auth.service";
import { ContactDetailsService } from "../shared/module/contact-details/contact.details.service";
import { UserService } from "../shared/user.service";
import { VenueService } from "./venue.service";

@Component({
  selector: "mlp-venue",
  templateUrl: "venue.component.html",
  styleUrls: ["./venue.component.scss"],
})
export class VenueComponent implements OnInit, OnDestroy {
  @ViewChild("ngModal") marketingPopup: ElementRef;

  bookOnlineShow = true;
  @Output() openMapEvent = new EventEmitter();
  @Output() pitchesWithSameSport: Array<Pitch> = [];
  sport = "";
  notFound = false;

  private readonly isBrowser: boolean = isPlatformBrowser(this.platformId);
  private marketingPopupTimeout: NodeJS.Timer;

  constructor(
    @Inject(DOCUMENT) private readonly document,
    private readonly _meta: Meta,
    private readonly _title: Title,
    private readonly activatedRoute: ActivatedRoute,
    private readonly cookieService: CookieService,
    private readonly sportToPitchCourtTextPipe: SportToPitchCourtTextPipe,
    private readonly headerService: HeaderService,
    @Inject(PLATFORM_ID) private readonly platformId,
    public authService: AuthService,
    public cityService: CitySelectService,
    public contactService: ContactDetailsService,
    public modalService: ModalService,
    public userService: UserService,
    public venueService: VenueService
  ) {
    this.venueService.pitchDataChange.subscribe((returnedData: PitchData) => {
        this.sport = returnedData.data.attributes.sport;
      },
      this.processError
    );

    this.venueService.venueDataChange.subscribe(
      (returnedVenueData: VenueData) => {
        if (returnedVenueData) {
          this.extractPitchesWithSameSport(returnedVenueData.included);
          this.updateHeadTags();
        } else {
          this.processError();
        }
      },
      this.processError
    );
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(() => {
      if (this.isBrowser) {
        document.body.scrollTop = 0;

        this.checkUserMarketingProfile();
      }
      this.updateHeadTags();
    });
  }

  ngOnDestroy(): void {
    if (this.marketingPopupTimeout) {
      clearTimeout(this.marketingPopupTimeout);
    }
  }

  footerAction(widgetUrl: string): void {
    if (widgetUrl) {
      this.document.defaultView.open(widgetUrl, "_blank");
    } else {
      this.scrollToCalendar();
    }
  }

  checkUserMarketingProfile(): void {
    this.authService.sessionChecked.subscribe((checked) => {
      if (checked) {
        if (this.authService.user) {
          this.userService.getUserMarketingProfile().subscribe((profile) => {
            if (profile && !profile.data.attributes.optIn) {
              // TODO https://mylocalpitch.atlassian.net/browse/PF-2073
              // this.openDelayedMarketingPopup(6000);
            }
          });
        } else {
          if (!this.cookieService.get("marketing-opt-in")) {
            // TODO https://mylocalpitch.atlassian.net/browse/PF-2073
            // this.openDelayedMarketingPopup(6000);
          }
        }
      } else {
        this.authService
          .userGetMe()
          .subscribe((_) => this.checkUserMarketingProfile());
      }
    });
  }

  openDelayedMarketingPopup(delay: number): void {
    if (!this.marketingPopupTimeout) {
      this.marketingPopupTimeout = setTimeout(
        () =>
          this.modalService
            .open(this.marketingPopup, {
              windowClass: "sg-modal-banner-plain",
            })
            .result.then(
              (_) => this.marketingDismiss(),
              (_) => this.marketingDismiss()
            ),
        delay
      );
    }
  }

  marketingDismiss(): void {
    this.cookieService.put("marketing-opt-in", "true", {
      expires: new Date(+new Date() + 86400000),
    });
  }

  marketingSignup(): void {
    if (this.authService.user) {
      this.userService
        .setMarketPreferences(true)
        .pipe(
          switchMap((_) =>
            this.userService.setMarketPreferencesFields({
              CITY: this.cityService.city.name,
              AREA: "Central",
              SPORT: this.sport
                ? this.sport[0].toUpperCase() + this.sport.slice(1)
                : "",
            })
          )
        )
        .subscribe();
    } else {
      (
        document.getElementById("mc-embedded-subscribe-form") as HTMLFormElement
      ).submit();
      this.cookieService.put("marketing-opt-in", "true");
    }

    this.modalService.close();
  }

  @HostListener("window:scroll", []) onWindowScroll(): void {
    const bodyTop = document.body.scrollTop;
    if (bodyTop < 350 || bodyTop > 1000) {
      this.bookOnlineShow = true;

      return;
    }

    this.bookOnlineShow = false;
  }

  extractPitchesWithSameSport(pitches: Array<Pitch>): void {
    this.pitchesWithSameSport = [];

    pitches.forEach((pitchData: Pitch) => {
      if (this.sport === pitchData.attributes.sport) {
        this.pitchesWithSameSport.push(pitchData);
      }
    });
  }

  scrollToEnquiry(): void {
    document.getElementById("mlp-enquiry").scrollIntoView();

    // adjust fixed header margin
    window.scrollBy(0, -55);
  }

  scrollToCalendar(): void {
    document.getElementById("mlp-calendar").scrollIntoView();

    // adjust fixed header margin
    window.scrollBy(0, -55);
  }

  private updateHeadTags(): void {
    if (this.venueService.pitchData && this.venueService.venueData) {
      this.headerService.updateShowPhone(
        this.venueService.pitchData.data.attributes.mlp
      );
      const council = this.venueService.venueData.data.attributes.council;
      const venueName = this.venueService.venueData.data.attributes.name;
      const city = this.activatedRoute.snapshot.params.city;
      const pitchParam = this.activatedRoute.snapshot.params.sportFormatPitchId;
      const venueSport = this.venueService.pitchData.data.attributes.sport;
      const currentSportPitchCourtTexts =
        this.sportToPitchCourtTextPipe.transform(
          venueSport,
          "",
          this.venueService.venueData
        );
      const allSportPitchCourtTexts =
        this.getAllSportPitchCourtTexts().toLowerCase();

      const title =
        venueName +
        (council ? ", " + council : "") +
        " | " +
        (pitchParam ? currentSportPitchCourtTexts : "Sports Facility Hire") +
        " | Playfinder";
      let metaDescription = "";
      const keywords =
        venueName +
        ", " +
        (council ? council + ", " : "") +
        city +
        ", Playfinder, hire, book, opening hours, prices, " +
        allSportPitchCourtTexts;

      if (this.venueService.pitchData.data.attributes.mlp) {
        metaDescription =
          venueName +
          " is a sports facility located in " +
          (council ? council + ", " : "") +
          MlpHelper.uppercaseFirstLetter(city) +
          " and is available to book online. " +
          "Find out the address, opening hours and prices. Use Playfinder to hire the " +
          (pitchParam
            ? currentSportPitchCourtTexts.toLowerCase()
            : allSportPitchCourtTexts) +
          ".";
      } else {
        metaDescription =
          venueName +
          " is a sports facility located in " +
          (council ? council + ", " : "") +
          MlpHelper.uppercaseFirstLetter(city) +
          ". " +
          "Find out the address, contact details, opening hours and prices. Use Playfinder to discover more, and enquire online, about the " +
          (pitchParam
            ? currentSportPitchCourtTexts.toLowerCase()
            : allSportPitchCourtTexts) +
          ".";
      }

      if (this._title.getTitle() !== title) {
        this._title.setTitle(title);
      }
      this._meta.updateTag({
        name: "description",
        content: metaDescription,
      });
      this._meta.updateTag({
        name: "keywords",
        content: keywords.toLowerCase(),
      });
    }
  }

  private getAllSportPitchCourtTexts(): string {
    const textCollections = [];
    this.venueService.venueData.included.forEach((pitch: Pitch) => {
      const pitchText = this.sportToPitchCourtTextPipe.transform(
        pitch.attributes.sport,
        "",
        this.venueService.venueData
      );

      if (textCollections.indexOf(pitchText) === -1) {
        textCollections.push(pitchText);
      }
    });

    return textCollections.join(", ");
  }
  private processError(): void {
    this.notFound = true;
  }
}
